<div class="modal-body">
  <div class="block block-text narrow-content">
    <div class="text-center">
      <lh-shared-ui-spinner [visible]="!isInitialized"></lh-shared-ui-spinner>
    </div>

    <div *ngIf="showTimer" class="timer-container">
      <lh-storage-timer
        *ngIf="isInitialized"
        [booking]="booking"
        [isCheckInSession]="isCheckInSession && isFirstShow"
        [border]="true"
      >
      </lh-storage-timer>

      <!-- <div class="timer-text">
        {{ 'REMEMBER_TO_STOP_THE_TIMER' | translate }}
        <a class="href" (click)="done()">{{ 'STOP_TIMER_NOW' | translate }}</a>
      </div> -->
    </div>

    <!-- <div class="callout">
      {{ 'TIME_TO_HAVE_FUN' | translate }}
    </div>

    <div class="experience-heading">
      <span class="text-warning">{{ 'BEST_PRICE_GUARANTEE' | translate }}</span>
      <span> {{ 'ON_MOST_POPULAR_ACTIVITIES_IN_CITY' | translate }} {{ shop.officialLocationKey | translate }}</span>
    </div> -->

    <div *ngIf="isInitialized">
      <div *ngIf="provider === 'Tiqets'">
        <div class="experience-heading-sm">
          <strong>{{ 'EXCLUSIVE' | translate }}</strong> — {{ 'USE_TIQETS_DISCOUNT_CODE' | translate }}
          {{ shop.officialLocationKey | translate }}:
        </div>

        <!-- Tiqets iframe -->
        <div class="tiqets-iframe-container">
          <iframe [src]="tiqetsIframeUrl | safeUrl" class="tiqets-iframe" frameborder="0" scrolling="no"></iframe>
        </div>
      </div>

      <div *ngIf="provider === 'GetYourGuide'">
        <!-- GetYourGuide iframe -->
        <iframe
          *ngIf="gygIframeUrl"
          [src]="gygIframeUrl | safeUrl"
          class="gyg-iframe"
          frameborder="0"
          scrolling="no"
        ></iframe>

        <!-- GetYourGuide widget -->
        <div
          *ngIf="gygConfig"
          [attr.data-gyg-partner-id]="gygConfig.partnerId"
          [attr.data-gyg-number-of-items]="gygConfig.numberOfItems"
          [attr.data-gyg-currency]="gygConfig.currency"
          [attr.data-gyg-locale-code]="gygConfig.locale"
          [attr.data-gyg-cmp]="gygConfig.campaign"
          [attr.data-gyg-placement]="gygConfig.placement"
          [attr.data-gyg-see-more]="gygConfig.enableSeeMore"
          [attr.data-gyg-id]="gygConfig.id"
          [attr.data-gyg-tour-ids]="gygConfig.tourIds"
          [attr.data-gyg-lat]="gygConfig.lat"
          [attr.data-gyg-lon]="gygConfig.lon"
          [attr.data-gyg-widget]="gygConfig.widgetType"
          [attr.data-gyg-href]="gygConfig.widgetUrl"
        ></div>
      </div>

      <!-- Custom list of experiences -->
      <div *ngIf="provider === 'LuggageHero'">
        <h3 class="mb-4">3 tips to enjoy Copenhagen without your luggage</h3>

        <ul class="experience-list">
          <a
            [id]="'goToExperienceLink_' + experience.name"
            *ngFor="let experience of experiences"
            class="experience-item"
            target="_blank"
            [href]="experience.linkUrl"
          >
            <div>
              <img [src]="experience.imageUrl" class="experience-img" />
              <div class="experience-cta">
                <button [id]="'goToExperienceButton_' + experience.name" class="btn btn-primary btn-experience">
                  {{ experience.callToAction }}
                </button>
              </div>
            </div>

            <div class="experience-text">
              <h4 class="experience-title">
                {{ experience.title }}
                <div class="experience-subtitle" *ngIf="experience.subtitle">{{ experience.subtitle }}</div>
              </h4>
              <div class="experience-desc">{{ experience.description }}</div>
            </div>
          </a>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button id="returnToBooking" class="btn btn-block btn-primary" (click)="done()">
    {{ 'RETURN_TO_BOOKING' | translate }}
  </button>
</div>
